// Site branding data for Alexander Conti Realty

// Round AC monogram — used as small avatar/logo in header
export const LOGO_URL = '/brand/logo.jpeg';
// Full brand logo w/ tagline — used on About Me hero + footer
export const LOGO_FULL_URL = '/brand/logo-full.jpeg';

export const COMPANY_INFO = {
  name: 'Alexander Conti',
  title: 'REALTOR®',
  tagline: 'Your Vision, My Mission',
  phone: '226-934-4107',
  email: 'alexanderconti@brantfordareahomes.ca',
  website: 'brantfordareahomes.ca',
  address: '46 Charing Cross St, Unit 2, Brantford, ON N3R 2H3',
  brokerage: 'Royal LePage Brant Realty',
};

export const SOCIAL_MEDIA = {
  facebook: 'https://www.facebook.com/brantfordareahomes',
  instagram: 'https://www.instagram.com/brantfordareahomes',
};

export const COVERAGE_AREAS = [
  { id: 'brantford', name: 'Brantford', type: 'city', province: 'ON' },
  { id: 'burford', name: 'Burford', type: 'city', province: 'ON' },
  { id: 'burlington', name: 'Burlington', type: 'city', province: 'ON' },
  { id: 'caledonia', name: 'Caledonia', type: 'city', province: 'ON' },
  { id: 'cambridge', name: 'Cambridge', type: 'city', province: 'ON' },
  { id: 'grimsby', name: 'Grimsby', type: 'city', province: 'ON' },
  { id: 'guelph', name: 'Guelph', type: 'city', province: 'ON' },
  { id: 'hagersville', name: 'Hagersville', type: 'city', province: 'ON' },
  { id: 'hamilton', name: 'Hamilton', type: 'city', province: 'ON' },
  { id: 'kitchener', name: 'Kitchener', type: 'city', province: 'ON' },
  { id: 'milton', name: 'Milton', type: 'city', province: 'ON' },
  { id: 'mississauga', name: 'Mississauga', type: 'city', province: 'ON' },
  { id: 'mount-pleasant', name: 'Mount Pleasant', type: 'city', province: 'ON' },
  { id: 'oakville', name: 'Oakville', type: 'city', province: 'ON' },
  { id: 'paris', name: 'Paris', type: 'city', province: 'ON' },
  { id: 'st-george', name: 'St George', type: 'city', province: 'ON' },
  { id: 'waterford', name: 'Waterford', type: 'city', province: 'ON' },
  { id: 'waterloo', name: 'Waterloo', type: 'city', province: 'ON' },
  { id: 'woodstock', name: 'Woodstock', type: 'city', province: 'ON' },
  { id: 'ancaster', name: 'Ancaster', type: 'city', province: 'ON' },
];

export const NEIGHBORHOOD_DATA = {
  'brantford': {
    name: 'Brantford',
    description: 'Brantford offers a unique blend of small-town charm and urban convenience. Known as the "Telephone City" as the birthplace of the telephone, it features beautiful heritage architecture, affordable housing, and excellent access to larger cities via Highway 403.',
    image: 'https://ddfcdn.realtor.ca/listing/TS639071990037800000/reb82/highres/2/x12807042_1.jpg',
    avgPrice: 649900,
    priceChange: 2.3,
    avgDaysOnMarket: 28,
    activeListings: 156,
    walkScore: 62,
    transitScore: 45,
    bikeScore: 58,
    schoolRating: 7.2,
    crimeRate: 'Low',
    amenitiesRating: 8.1,
    priceHistory: [
      { month: 'Jan', price: 625000 },
      { month: 'Feb', price: 632000 },
      { month: 'Mar', price: 641000 },
      { month: 'Apr', price: 645000 },
      { month: 'May', price: 649000 },
      { month: 'Jun', price: 649900 },
    ],
  },
  'burford': {
    name: 'Burford',
    description: 'Burford is a charming village in Brant County offering rural living with easy access to Brantford and the 403. Known for its historic downtown, farmers markets, and peaceful countryside setting.',
    image: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=1200&q=80&auto=format&fit=crop',
    avgPrice: 725000,
    priceChange: 3.1,
    avgDaysOnMarket: 35,
    activeListings: 28,
    walkScore: 35,
    transitScore: 10,
    bikeScore: 40,
    schoolRating: 7.5,
    crimeRate: 'Very Low',
    amenitiesRating: 6.5,
    priceHistory: [
      { month: 'Jan', price: 695000 },
      { month: 'Feb', price: 702000 },
      { month: 'Mar', price: 710000 },
      { month: 'Apr', price: 715000 },
      { month: 'May', price: 720000 },
      { month: 'Jun', price: 725000 },
    ],
  },
  'burlington': {
    name: 'Burlington',
    description: 'Burlington is a vibrant lakeside city offering excellent schools, beautiful waterfront trails, and a thriving downtown. Its proximity to Toronto and Hamilton makes it ideal for commuters seeking suburban quality of life.',
    image: 'https://ddfcdn.realtor.ca/listing/TS639052842918800000/reb14/highres/3/40789783_1.jpg',
    avgPrice: 1150000,
    priceChange: 1.8,
    avgDaysOnMarket: 22,
    activeListings: 245,
    walkScore: 55,
    transitScore: 50,
    bikeScore: 52,
    schoolRating: 8.5,
    crimeRate: 'Low',
    amenitiesRating: 8.8,
    priceHistory: [
      { month: 'Jan', price: 1105000 },
      { month: 'Feb', price: 1115000 },
      { month: 'Mar', price: 1128000 },
      { month: 'Apr', price: 1138000 },
      { month: 'May', price: 1145000 },
      { month: 'Jun', price: 1150000 },
    ],
  },
  'caledonia': {
    name: 'Caledonia',
    description: 'Caledonia is a growing community along the Grand River offering small-town charm with modern amenities. Popular with families for its affordable housing, good schools, and recreational opportunities.',
    image: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=1200&q=80&auto=format&fit=crop',
    avgPrice: 695000,
    priceChange: 3.5,
    avgDaysOnMarket: 30,
    activeListings: 62,
    walkScore: 45,
    transitScore: 15,
    bikeScore: 42,
    schoolRating: 7.6,
    crimeRate: 'Very Low',
    amenitiesRating: 7.0,
    priceHistory: [
      { month: 'Jan', price: 665000 },
      { month: 'Feb', price: 672000 },
      { month: 'Mar', price: 680000 },
      { month: 'Apr', price: 686000 },
      { month: 'May', price: 692000 },
      { month: 'Jun', price: 695000 },
    ],
  },
  'cambridge': {
    name: 'Cambridge',
    description: 'Cambridge combines three historic communities - Galt, Preston, and Hespeler - into one diverse city. Known for its heritage architecture, the Grand River, and strong manufacturing sector.',
    image: 'https://ddfcdn.realtor.ca/listing/TS639065079310870000/reb82/highres/8/x12784598_1.jpg',
    avgPrice: 785000,
    priceChange: 2.4,
    avgDaysOnMarket: 26,
    activeListings: 178,
    walkScore: 52,
    transitScore: 42,
    bikeScore: 55,
    schoolRating: 7.8,
    crimeRate: 'Low',
    amenitiesRating: 7.9,
    priceHistory: [
      { month: 'Jan', price: 755000 },
      { month: 'Feb', price: 762000 },
      { month: 'Mar', price: 770000 },
      { month: 'Apr', price: 776000 },
      { month: 'May', price: 782000 },
      { month: 'Jun', price: 785000 },
    ],
  },
  'grimsby': {
    name: 'Grimsby',
    description: 'Grimsby is a picturesque town on the Niagara Escarpment offering stunning views, wineries, and beach access. Its charming downtown and proximity to Hamilton attract young professionals and families.',
    image: 'https://ddfcdn.realtor.ca/listing/TS639072603844230000/reb82/highres/4/x12798564_1.jpg',
    avgPrice: 895000,
    priceChange: 2.2,
    avgDaysOnMarket: 24,
    activeListings: 85,
    walkScore: 48,
    transitScore: 35,
    bikeScore: 45,
    schoolRating: 8.0,
    crimeRate: 'Very Low',
    amenitiesRating: 7.5,
    priceHistory: [
      { month: 'Jan', price: 865000 },
      { month: 'Feb', price: 872000 },
      { month: 'Mar', price: 880000 },
      { month: 'Apr', price: 886000 },
      { month: 'May', price: 892000 },
      { month: 'Jun', price: 895000 },
    ],
  },
  'guelph': {
    name: 'Guelph',
    description: 'Guelph is a vibrant university city known for its strong economy, excellent schools, and environmental leadership. The historic downtown, diverse dining scene, and arts culture make it highly desirable.',
    image: 'https://ddfcdn.realtor.ca/listing/TS639072678555070000/reb14/highres/8/40802658_1.jpg',
    avgPrice: 875000,
    priceChange: 1.9,
    avgDaysOnMarket: 21,
    activeListings: 165,
    walkScore: 65,
    transitScore: 55,
    bikeScore: 68,
    schoolRating: 8.4,
    crimeRate: 'Low',
    amenitiesRating: 8.5,
    priceHistory: [
      { month: 'Jan', price: 845000 },
      { month: 'Feb', price: 852000 },
      { month: 'Mar', price: 860000 },
      { month: 'Apr', price: 866000 },
      { month: 'May', price: 872000 },
      { month: 'Jun', price: 875000 },
    ],
  },
  'hagersville': {
    name: 'Hagersville',
    description: 'Hagersville is a small town in Haldimand County offering affordable rural living. Known for its tight-knit community, local shops, and easy access to larger centres via Highway 6.',
    image: 'https://ddfcdn.realtor.ca/listing/TS639065891626600000/reb14/highres/0/40805190_1.jpg',
    avgPrice: 595000,
    priceChange: 4.1,
    avgDaysOnMarket: 38,
    activeListings: 22,
    walkScore: 55,
    transitScore: 10,
    bikeScore: 45,
    schoolRating: 7.2,
    crimeRate: 'Very Low',
    amenitiesRating: 6.0,
    priceHistory: [
      { month: 'Jan', price: 565000 },
      { month: 'Feb', price: 572000 },
      { month: 'Mar', price: 580000 },
      { month: 'Apr', price: 586000 },
      { month: 'May', price: 592000 },
      { month: 'Jun', price: 595000 },
    ],
  },
  'hamilton': {
    name: 'Hamilton',
    description: 'Hamilton is a dynamic city that balances industrial heritage with a thriving creative and culinary culture. Known for its stunning waterfalls, vibrant arts scene, and revitalized downtown, it\'s become a magnet for young professionals.',
    image: 'https://ddfcdn.realtor.ca/listing/TS639071922696430000/reb82/highres/6/x12806346_1.jpg',
    avgPrice: 789000,
    priceChange: 1.8,
    avgDaysOnMarket: 22,
    activeListings: 342,
    walkScore: 71,
    transitScore: 58,
    bikeScore: 65,
    schoolRating: 7.8,
    crimeRate: 'Medium',
    amenitiesRating: 8.5,
    priceHistory: [
      { month: 'Jan', price: 765000 },
      { month: 'Feb', price: 772000 },
      { month: 'Mar', price: 778000 },
      { month: 'Apr', price: 782000 },
      { month: 'May', price: 786000 },
      { month: 'Jun', price: 789000 },
    ],
  },
  'kitchener': {
    name: 'Kitchener',
    description: 'Kitchener is a thriving tech hub in the heart of Waterloo Region. Known for its innovative spirit, diverse population, and strong economy, it offers urban amenities while maintaining affordability.',
    image: 'https://ddfcdn.realtor.ca/listing/TS639070177062730000/reb14/highres/7/40804127_1.jpg',
    avgPrice: 745000,
    priceChange: 2.1,
    avgDaysOnMarket: 23,
    activeListings: 225,
    walkScore: 58,
    transitScore: 52,
    bikeScore: 60,
    schoolRating: 7.9,
    crimeRate: 'Low',
    amenitiesRating: 8.2,
    priceHistory: [
      { month: 'Jan', price: 715000 },
      { month: 'Feb', price: 722000 },
      { month: 'Mar', price: 730000 },
      { month: 'Apr', price: 736000 },
      { month: 'May', price: 742000 },
      { month: 'Jun', price: 745000 },
    ],
  },
  'milton': {
    name: 'Milton',
    description: 'Milton is one of Canada\'s fastest-growing communities, offering new subdivisions, excellent schools, and easy GO Transit access to Toronto. The Niagara Escarpment provides stunning natural beauty.',
    image: 'https://ddfcdn.realtor.ca/listing/TS639072670568070000/reb82/highres/0/w12799600_1.jpg',
    avgPrice: 1195000,
    priceChange: 1.6,
    avgDaysOnMarket: 25,
    activeListings: 145,
    walkScore: 42,
    transitScore: 48,
    bikeScore: 45,
    schoolRating: 8.3,
    crimeRate: 'Very Low',
    amenitiesRating: 7.8,
    priceHistory: [
      { month: 'Jan', price: 1155000 },
      { month: 'Feb', price: 1165000 },
      { month: 'Mar', price: 1175000 },
      { month: 'Apr', price: 1182000 },
      { month: 'May', price: 1190000 },
      { month: 'Jun', price: 1195000 },
    ],
  },
  'mississauga': {
    name: 'Mississauga',
    description: 'Mississauga is Canada\'s sixth-largest city, offering diverse neighborhoods, excellent transit connections to Toronto, and a rapidly growing downtown core. From waterfront trails to world-class shopping, it has something for everyone.',
    image: 'https://ddfcdn.realtor.ca/listing/TS639070277606400000/reb82/highres/4/w12799314_1.jpg',
    avgPrice: 1125000,
    priceChange: 1.5,
    avgDaysOnMarket: 26,
    activeListings: 456,
    walkScore: 58,
    transitScore: 65,
    bikeScore: 52,
    schoolRating: 8.1,
    crimeRate: 'Low',
    amenitiesRating: 8.8,
    priceHistory: [
      { month: 'Jan', price: 1085000 },
      { month: 'Feb', price: 1095000 },
      { month: 'Mar', price: 1105000 },
      { month: 'Apr', price: 1112000 },
      { month: 'May', price: 1120000 },
      { month: 'Jun', price: 1125000 },
    ],
  },
  'mount-pleasant': {
    name: 'Mount Pleasant',
    description: 'Mount Pleasant is a growing community just north of Brantford offering newer homes and family-friendly amenities. Its location provides easy access to both Brantford and Cambridge.',
    image: 'https://ddfcdn.realtor.ca/listing/TS639064924987530000/reb13/highres/4/x12778784_1.jpg',
    avgPrice: 785000,
    priceChange: 2.8,
    avgDaysOnMarket: 28,
    activeListings: 35,
    walkScore: 25,
    transitScore: 10,
    bikeScore: 30,
    schoolRating: 7.8,
    crimeRate: 'Very Low',
    amenitiesRating: 6.8,
    priceHistory: [
      { month: 'Jan', price: 755000 },
      { month: 'Feb', price: 762000 },
      { month: 'Mar', price: 770000 },
      { month: 'Apr', price: 776000 },
      { month: 'May', price: 782000 },
      { month: 'Jun', price: 785000 },
    ],
  },
  'oakville': {
    name: 'Oakville',
    description: 'Oakville is one of Canada\'s most affluent communities, featuring beautiful lakefront properties, top-rated schools, and an upscale downtown. Its proximity to Toronto while maintaining a suburban feel makes it ideal for commuters.',
    image: 'https://ddfcdn.realtor.ca/listing/TS639071101454000000/reb15/highres/4/w12803054_1.jpg',
    avgPrice: 1650000,
    priceChange: 2.1,
    avgDaysOnMarket: 24,
    activeListings: 198,
    walkScore: 55,
    transitScore: 52,
    bikeScore: 48,
    schoolRating: 9.2,
    crimeRate: 'Very Low',
    amenitiesRating: 9.0,
    priceHistory: [
      { month: 'Jan', price: 1580000 },
      { month: 'Feb', price: 1595000 },
      { month: 'Mar', price: 1615000 },
      { month: 'Apr', price: 1630000 },
      { month: 'May', price: 1642000 },
      { month: 'Jun', price: 1650000 },
    ],
  },
  'paris': {
    name: 'Paris',
    description: 'Paris is known as "The Prettiest Little Town in Canada" with its cobblestone streets, heritage architecture, and Grand River setting. A popular destination for day-trippers and those seeking small-town living.',
    image: 'https://ddfcdn.realtor.ca/listing/TS639072186379130000/reb14/highres/4/40803334_1.jpg',
    avgPrice: 825000,
    priceChange: 2.9,
    avgDaysOnMarket: 27,
    activeListings: 45,
    walkScore: 68,
    transitScore: 15,
    bikeScore: 55,
    schoolRating: 7.9,
    crimeRate: 'Very Low',
    amenitiesRating: 7.5,
    priceHistory: [
      { month: 'Jan', price: 795000 },
      { month: 'Feb', price: 802000 },
      { month: 'Mar', price: 810000 },
      { month: 'Apr', price: 816000 },
      { month: 'May', price: 822000 },
      { month: 'Jun', price: 825000 },
    ],
  },
  'st-george': {
    name: 'St George',
    description: 'St George is a quiet village in Brant County known for its rural character and proximity to Paris and Brantford. Ideal for those seeking peaceful country living with access to urban amenities.',
    image: 'https://ddfcdn.realtor.ca/listing/TS639050331938870000/reb82/highres/4/x12583504_1.jpg',
    avgPrice: 795000,
    priceChange: 3.2,
    avgDaysOnMarket: 32,
    activeListings: 18,
    walkScore: 20,
    transitScore: 5,
    bikeScore: 25,
    schoolRating: 7.5,
    crimeRate: 'Very Low',
    amenitiesRating: 5.5,
    priceHistory: [
      { month: 'Jan', price: 765000 },
      { month: 'Feb', price: 772000 },
      { month: 'Mar', price: 780000 },
      { month: 'Apr', price: 786000 },
      { month: 'May', price: 792000 },
      { month: 'Jun', price: 795000 },
    ],
  },
  'waterford': {
    name: 'Waterford',
    description: 'Waterford is a charming village in Norfolk County offering affordable homes and a strong sense of community. Known for its heritage buildings, pumpkinfest, and proximity to Lake Erie beaches.',
    image: 'https://ddfcdn.realtor.ca/listing/TS639065891626600000/reb14/highres/0/40805190_1.jpg',
    avgPrice: 565000,
    priceChange: 4.5,
    avgDaysOnMarket: 36,
    activeListings: 24,
    walkScore: 55,
    transitScore: 5,
    bikeScore: 40,
    schoolRating: 7.0,
    crimeRate: 'Very Low',
    amenitiesRating: 6.0,
    priceHistory: [
      { month: 'Jan', price: 535000 },
      { month: 'Feb', price: 542000 },
      { month: 'Mar', price: 550000 },
      { month: 'Apr', price: 556000 },
      { month: 'May', price: 562000 },
      { month: 'Jun', price: 565000 },
    ],
  },
  'waterloo': {
    name: 'Waterloo',
    description: 'Waterloo is home to two world-class universities and a booming tech sector. The vibrant uptown area, diverse restaurants, and innovative culture make it attractive to students, professionals, and families.',
    image: 'https://ddfcdn.realtor.ca/listing/TS639069420641030000/reb14/highres/0/40799480_1.jpg',
    avgPrice: 825000,
    priceChange: 1.7,
    avgDaysOnMarket: 20,
    activeListings: 142,
    walkScore: 62,
    transitScore: 58,
    bikeScore: 72,
    schoolRating: 8.6,
    crimeRate: 'Low',
    amenitiesRating: 8.7,
    priceHistory: [
      { month: 'Jan', price: 795000 },
      { month: 'Feb', price: 802000 },
      { month: 'Mar', price: 810000 },
      { month: 'Apr', price: 816000 },
      { month: 'May', price: 822000 },
      { month: 'Jun', price: 825000 },
    ],
  },
  'woodstock': {
    name: 'Woodstock',
    description: 'Woodstock is a historic city in Oxford County known as "The Dairy Capital of Canada". It offers affordable housing, a charming downtown, and strong community spirit with easy access to London and the 401.',
    image: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800',
    avgPrice: 625000,
    priceChange: 3.4,
    avgDaysOnMarket: 29,
    activeListings: 95,
    walkScore: 58,
    transitScore: 25,
    bikeScore: 52,
    schoolRating: 7.5,
    crimeRate: 'Low',
    amenitiesRating: 7.2,
    priceHistory: [
      { month: 'Jan', price: 595000 },
      { month: 'Feb', price: 602000 },
      { month: 'Mar', price: 610000 },
      { month: 'Apr', price: 616000 },
      { month: 'May', price: 622000 },
      { month: 'Jun', price: 625000 },
    ],
  },
  'ancaster': {
    name: 'Ancaster',
    description: 'Ancaster is an affluent community within Hamilton known for its excellent schools, beautiful heritage homes, and scenic trails. The charming village atmosphere combined with modern amenities makes it highly desirable for families.',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800',
    avgPrice: 1150000,
    priceChange: 3.2,
    avgDaysOnMarket: 18,
    activeListings: 87,
    walkScore: 45,
    transitScore: 35,
    bikeScore: 42,
    schoolRating: 8.9,
    crimeRate: 'Very Low',
    amenitiesRating: 7.8,
    priceHistory: [
      { month: 'Jan', price: 1095000 },
      { month: 'Feb', price: 1105000 },
      { month: 'Mar', price: 1120000 },
      { month: 'Apr', price: 1135000 },
      { month: 'May', price: 1145000 },
      { month: 'Jun', price: 1150000 },
    ],
  },
};

export const PROPERTY_TYPES = [
  { value: 'all', label: 'All Types' },
  { value: 'detached', label: 'Detached' },
  { value: 'semi-detached', label: 'Semi-Detached' },
  { value: 'townhouse', label: 'Townhouse' },
  { value: 'condo', label: 'Condo/Apartment' },
  { value: 'multi-family', label: 'Multi-Family' },
  { value: 'land', label: 'Land' },
  { value: 'commercial', label: 'Commercial' },
];

export const FEATURED_LISTINGS = [
  {
    id: '1',
    mlsNumber: 'X12808968',
    price: 799888,
    address: '35 Wilmot Road',
    city: 'Brantford',
    province: 'ON',
    postalCode: 'N3T 5L4',
    beds: 4,
    baths: 4,
    sqft: 2800,
    lotSize: '50 x 120 ft',
    propertyType: 'Detached',
    status: 'Active',
    daysOnMarket: 5,
    yearBuilt: 2020,
    image: 'https://ddfcdn.realtor.ca/listing/TS639072744768000000/reb82/highres/8/x12808968_1.jpg',
    images: [
      'https://ddfcdn.realtor.ca/listing/TS639072744768000000/reb82/highres/8/x12808968_1.jpg',
    ],
    description: 'Beautiful 4 bedroom home in Brantford. Modern finishes throughout with spacious living areas.',
    features: ['Hardwood Floors', 'Modern Kitchen', 'Double Garage', 'Central Air'],
    virtualTour: false,
  },
  {
    id: '2',
    mlsNumber: '40801112',
    price: 599900,
    address: '54 Glenwood Drive Unit 15',
    city: 'Brantford',
    province: 'ON',
    postalCode: 'N3R 7J5',
    beds: 3,
    baths: 2,
    sqft: 1164,
    lotSize: 'Condo',
    propertyType: 'Townhouse',
    status: 'Active',
    daysOnMarket: 12,
    yearBuilt: 2018,
    image: 'https://ddfcdn.realtor.ca/listing/TS639051050432830000/reb41/highres/2/40801112_1.jpg',
    images: [
      'https://ddfcdn.realtor.ca/listing/TS639051050432830000/reb41/highres/2/40801112_1.jpg',
    ],
    description: 'Well-maintained 3 bedroom townhouse in desirable Glenwood neighborhood.',
    features: ['Open Concept', 'Attached Garage', 'Modern Kitchen'],
    virtualTour: false,
  },
  {
    id: '3',
    mlsNumber: '40806747',
    price: 549000,
    address: '149 Elgin Street',
    city: 'Brantford',
    province: 'ON',
    postalCode: 'N3T 4B8',
    beds: 3,
    baths: 2,
    sqft: 1435,
    lotSize: '40 x 100 ft',
    propertyType: 'Detached',
    status: 'Active',
    daysOnMarket: 8,
    yearBuilt: 1950,
    image: 'https://ddfcdn.realtor.ca/listing/TS639072774547900000/reb14/highres/7/40806747_1.jpg',
    images: [
      'https://ddfcdn.realtor.ca/listing/TS639072774547900000/reb14/highres/7/40806747_1.jpg',
    ],
    description: 'Charming 3 bedroom home on Elgin Street. Great starter home with lots of potential.',
    features: ['Updated Kitchen', 'Large Lot', 'Mature Trees'],
    virtualTour: false,
  },
  {
    id: '4',
    mlsNumber: 'X12803054',
    price: 699000,
    address: '28 Grand River Blvd',
    city: 'Paris',
    province: 'ON',
    postalCode: 'N3L 2E4',
    beds: 4,
    baths: 3,
    sqft: 2200,
    lotSize: '60 x 130 ft',
    propertyType: 'Detached',
    status: 'Active',
    daysOnMarket: 3,
    yearBuilt: 2019,
    image: 'https://ddfcdn.realtor.ca/listing/TS639071101454000000/reb15/highres/4/w12803054_1.jpg',
    images: [
      'https://ddfcdn.realtor.ca/listing/TS639071101454000000/reb15/highres/4/w12803054_1.jpg',
    ],
    description: 'Beautiful home in Paris near the Grand River. Modern finishes throughout.',
    features: ['River Views', 'Open Concept', 'Premium Finishes', 'Double Garage'],
    virtualTour: true,
  },
  {
    id: '5',
    mlsNumber: 'X12345682',
    price: 649900,
    address: '23 Paris Rd',
    city: 'Paris',
    province: 'ON',
    postalCode: 'N3L 2M3',
    beds: 3,
    baths: 2,
    sqft: 1650,
    lotSize: '45 x 110 ft',
    propertyType: 'Detached',
    status: 'Active',
    daysOnMarket: 15,
    yearBuilt: 2010,
    image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800',
    images: [
      'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800',
    ],
    description: 'Charming home in the prettiest little town in Canada. Walking distance to downtown shops and Grand River trails.',
    features: ['Open Concept', 'Gas Fireplace', 'Ensuite Bath', 'Fenced Yard'],
    virtualTour: false,
  },
  {
    id: '6',
    mlsNumber: 'X12345683',
    price: 575000,
    address: '156 St George St',
    city: 'St. George',
    province: 'ON',
    postalCode: 'N0E 1N0',
    beds: 4,
    baths: 2,
    sqft: 1800,
    lotSize: '55 x 120 ft',
    propertyType: 'Detached',
    status: 'Active',
    daysOnMarket: 7,
    yearBuilt: 2015,
    image: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800',
    images: [
      'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800',
    ],
    description: 'Beautiful family home in quiet St. George. Large lot with mature trees.',
    features: ['Large Lot', 'Updated Kitchen', 'Modern Finishes', 'Walk to School'],
    virtualTour: false,
  },
];

export const NEW_BUILDS = [
  {
    id: 'nb1',
    name: 'Brantford Commons',
    developer: 'Losani Homes',
    city: 'Brantford',
    priceFrom: 599900,
    priceTo: 899900,
    types: ['Townhomes', 'Detached'],
    completion: 'Fall 2025',
    image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800',
    description: 'Master-planned community featuring modern designs and premium finishes.',
  },
  {
    id: 'nb2',
    name: 'Waterfront Estates',
    developer: 'Empire Communities',
    city: 'Hamilton',
    priceFrom: 799900,
    priceTo: 1299900,
    types: ['Detached', 'Semi-Detached'],
    completion: 'Spring 2026',
    image: 'https://images.unsplash.com/photo-1600573472592-401b489a3cdc?w=800',
    description: 'Luxury waterfront living with stunning lake views and premium amenities.',
  },
];

// CMHC Insurance Rates (2024)
export const CMHC_RATES = [
  { minDownPayment: 5, maxDownPayment: 9.99, rate: 4.00 },
  { minDownPayment: 10, maxDownPayment: 14.99, rate: 3.10 },
  { minDownPayment: 15, maxDownPayment: 19.99, rate: 2.80 },
];

// Closing Costs Estimates
export const CLOSING_COSTS = {
  landTransferTax: {
    ontario: [
      { upTo: 55000, rate: 0.005 },
      { upTo: 250000, rate: 0.01 },
      { upTo: 400000, rate: 0.015 },
      { upTo: 2000000, rate: 0.02 },
      { above: 2000000, rate: 0.025 },
    ],
  },
  legalFees: { min: 1500, max: 2500 },
  titleInsurance: { rate: 0.001, min: 300 },
  homeInspection: { min: 400, max: 600 },
  appraisal: { min: 300, max: 500 },
};
